import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import {
  SystemToastPayload,
  SystemToastService,
} from '../../../core/services/system-toast.service';

@Component({
  selector: 'app-system-toast',
  standalone: false,
  templateUrl: './system-toast.component.html',
  styleUrl: './system-toast.component.scss',
})
export class SystemToastComponent implements OnInit, OnDestroy {
  toast: SystemToastPayload | null = null;
  fadeMs = 250;
  holdMs = 1800;

  private sub?: Subscription;
  private clearSub?: Subscription;

  constructor(private systemToastService: SystemToastService) {}

  ngOnInit(): void {
    this.sub = this.systemToastService.toast$.subscribe((toast) => {
      this.clearSub?.unsubscribe();

      if (!toast) {
        this.toast = null;
        return;
      }

      this.toast = toast;
      this.fadeMs = toast.fadeMs ?? 250;
      this.holdMs = toast.durationMs ?? 1800;

      const total = this.fadeMs + this.holdMs + this.fadeMs;
      this.clearSub = timer(total).subscribe(() => {
        this.systemToastService.clear();
      });
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.clearSub?.unsubscribe();
  }
}
